export enum ConnectionMode {
    OAUTH_CLIENT_CREDENTIALS = 'OAUTH_CLIENT_CREDENTIALS',
    CREDENTIALS_FORM = 'CREDENTIALS_FORM',
    /** Bexio: OAuth authorization-code flow (popup), owned by aumico-lib-companies-fe. */
    OAUTH_AUTH_CODE = 'OAUTH_AUTH_CODE',
}
